import _ from "lodash";

export type Status = "succeeded" | "failed" | "in_progress" | "pending" | "canceled";

export const statuses: Status[] = [
  "succeeded",
  "failed",
  "in_progress",
  "pending",
];

export const selectStatuses = statuses.map((status) => {
  return { value: status, label: status.replaceAll("_", " ").toUpperCase() };
});

export const colorsByStatus: Record<Status, string> = {
  succeeded: "green",
  failed: "red",
  in_progress: "orange",
  pending: "gray",
  canceled: "yellow",
};
